import { Component, Input, OnInit } from '@angular/core';
import { AuthMethodService } from 'src/app/services/auth-method.service';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';

@Component({
  selector: 'app-pin-entry-fsbs',
  templateUrl: './pin-entry-fsbs.component.html',
  styleUrls: ['./pin-entry-fsbs.component.scss']
})
export class PinEntryFsbsComponent implements OnInit {
  @Input('languages') languages: any;
  fileName: string = 'pinEntryFsbsComponent';
  constructor(
    public rootScope: RootScopeService,
    public authService: AuthMethodService,
    public logger: LogService,
    public genesysCloudService: GenesysCloudService) {

  }

  ngOnInit(): void {
  }

  onRadioChange(selectedCode): void {
    if (selectedCode) {
      this.rootScope.activeCustTab.selectedAlisLang = selectedCode;
    }
  }

  /**
   * @author - Amarjeet
   * Updates the telephony event data with FSBA PIN entry step 1 completion details.   
   */
  pinEntryAttrUpdate() {
    this.rootScope.activeCustTab.pinEntryApp.success = null;
    let body = this.authService.attributeBodyForFSBA()
    this.logger.infoLogs("request body of pinEntryAttrUpdate API payload:" + JSON.stringify(body), this.fileName);
    this.genesysCloudService
      .updateParticipantAttributes(this.rootScope.activeCustTab.conversationId, this.rootScope.activeCustTab.customerParticipantId, body)
      .subscribe({
        next: (res) => {
          if (res) {
            this.logger.debugLogs("pinEntryAttrUpdate in Step1 successfully called for customerSessionId:" + this.rootScope.activeCustTab.customerSessionId, this.fileName);
            this.rootScope.activeCustTab.pinEntryApp.step1Active = false;
            this.rootScope.activeCustTab.pinEntryApp.step1Complete = true;
            this.rootScope.activeCustTab.pinEntryApp.step2Active = true;
            //CCR3-6188 to track/log authmehtod events
            this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, "step1Completed successfully");
            this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);

          }
        },
        error: (err) => {
          this.logger.errorLogs(JSON.stringify(err), this.fileName);
        },
      });
  }

  /**
   * Cancels the PIN entry process and resets the application state to step 1.
   * @remarks
   * Updates the telephony event data with an "AuthCode.PIN" event type and 
   * "step1 Canceled" message for tracking purposes (CCR3-6188).
   * @author - Amarjeet
   */
  cancelButton() {
    this.rootScope.activeCustTab.pinEntryApp.step1Active = true;
    this.rootScope.activeCustTab.pinEntryApp.step1Complete = false;
    this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
    this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, "step1 Canceled");//CCR3-6188
  }
}
